import Vue from "vue";
import Router from "vue-router";
import store from "@src/common/lib/store";
import utils from "@src/common/utils";
import config from "@src/common/config";
import log from "@src/common/utils/log";

import common from "@src/common/router/common";
import test from "@src/common/router/test";
import assemble from "@src/common/router/assemble";
Vue.use(Router);

// 相同路由防重复点击
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  // 本地登录
  {
    // 登录页面路由地址
    path: "/login",
    name: "Login",
    alias: "",
    component: () => import("@src/common/view/Login"),
    meta: {
      requireAuth: false
    }
  },
  {
    // 调度大屏
    path: "/dispatchScreen",
    name: "DispatchScreen",
    alias: "",
    component: () => import("@src/common/view/dispatchScreen/index.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/userCode",
    name: "userCode",
    component: () => import("@src/common/view/user/UserCode.vue"),
    meta: {
      routerAlive: true
    }
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () =>
      import("@src/modules/forgetpassword/components/forgetPassword.vue"),
    meta: {
      routerAlive: true
    }
  },
  {
    path: "/identifycode",
    name: "   /identifycode",
    component: () =>
      import("@src/modules/forgetpassword/components/identifycode"),
    meta: {
      routerAlive: true
    }
  },
  {
    path: "/newpassword",
    name: "   /newpassword",
    component: () =>
      import("@src/modules/forgetpassword/components/newpassword"),
    meta: {
      routerAlive: true
    }
  },
  {
    // 系统首页路由地址
    path: "/security",
    name: "Security",
    component: () => import("@src/common/view/Security"),
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: "home",
        name: "HomePage",
        alias: "",
        component: () => import("@src/common/view/HomeNew"),
        meta: {
          requireAuth: true
          // routerAlive: true
        }
      },
      {
        // 用户中心
        path: "/usercenter",
        name: "usercenter",
        alias: "",
        component: () => import("@src/common/view/user/UserCenter"),
        meta: {
          requireAuth: false
        }
      },
      ...test,
      ...common,
      ...assemble.dependHome
    ]
  },
  ...assemble.dependApp
];

const router = new Router({
  routes
});
/**
 * 路由跳转前进行权限控制
 */
router.beforeEach((to, from, next) => {
  // 将当所有正在请求而未返回的请求取消，避免路由跳转后，请求中的数据又返回了
  if (
    window.axiosPromiseArr &&
    window.axiosPromiseArr.length &&
    to.path !== config.HOME_PAGE
  ) {
    window.axiosPromiseArr.forEach((req) => {
      req.cancel();
    });
    window.axiosPromiseArr.length = 0;
    window.axiosKeyArr.length = 0;
  }
  log.debug("跳转页面地址为：", to);
  // 待跳转的路由是否需要登录权限，如需要登录权限
  // 则判断当前用户是否已登录（根据缓存中是否有用户信息来判断）
  //     如用户未登录：则跳转至登录页面
  //     如用户已登录：则跳转至目标页面
  let userInfo = store.getters.userInfo;
  // 如果跳转的页面为用户登录页面，则在跳转前，将当前页面路径信息传入登录页面，用于登录成功后进行页面跳转
  if (to.path === config.LOGIN_PAGE && from.path !== config.LOGIN_PAGE) {
    // 没有页面参数的情况下，再将跳转前的页面路由信息传至登录页面，如果登录页面已经包含页面参数，则不再进行页面跳转
    if (!to.query && !to.params) {
      next({
        path: config.LOGIN_PAGE,
        query: utils.buildQueryParams({
          path: from.path,
          query: from.query,
          params: from.params
        })
      });
    } else {
      next();
    }
  } else if (to.meta && to.meta.requireAuth) {
    if (userInfo) {
      // 该代码暂时移除--------做权限校验--------
      // // 如果当前路由配置了权限码，则不进行路由跳转
      // if (to.meta.authCode && to.meta.authCode !== -1) {
      //   if (!utils.checkAuth(to.meta.authCode)) {
      //     log.warn('页面权限校验失败，阻止页面跳转。页面地址为：', to.path, '，页面权限码为：', to.meta.authCode);
      //     return;
      //   }
      // }
      next();
    } else {
      log.warn(
        "当前页面需要登录才能访问，检测用户信息为空，跳转至登录页面。页面地址为：",
        to.path
      );
      next({
        path: config.LOGIN_PAGE,
        query: utils.buildQueryParams({
          path: to.path,
          query: to.query,
          params: to.params
        })
      });
      // 跳转至登录页面时，同时清空本地缓存
      store.dispatch("clearUserCache");
    }
  } else {
    // 如果用户访问的路由在当前页面没有进行配置，则将路由跳转至首页
    if (!to || !to.name) {
      log.warn("访问的页面不存在，跳转至提示页面。页面地址为：", to.path);
      if (from.path !== config.PAGE_NOT_FOUND) {
        router.push({
          path: config.PAGE_NOT_FOUND
        });
      }
    } else {
      next();
    }
  }
});

export default router;
